import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';
import { subscriptionAPI } from '../../services/api';

export default function PaymentCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const [error, setError] = useState('');

  useEffect(() => {
    const tapId = searchParams.get('tap_id');
    if (!tapId) { setStatus('error'); setError('معرّف الدفع غير موجود'); return; }

    const verify = async () => {
      try {
        const res = await subscriptionAPI.verifyPayment({ charge_id: tapId });
        if (res.data?.data?.success) {
          setStatus('success');
          setTimeout(() => navigate('/settings/subscription', { replace: true }), 2000);
        } else {
          setStatus('error');
          setError('لم يتم إكمال الدفع');
        }
      } catch (err) {
        setStatus('error');
        setError(err.response?.data?.message || 'فشل التحقق من الدفع');
      }
    };
    verify();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" dir="rtl">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-sm w-full text-center">
        {status === 'verifying' && (
          <>
            <Loader2 className="w-12 h-12 text-blue-500 animate-spin mx-auto mb-4" />
            <h2 className="text-lg font-bold text-gray-800 mb-2">جاري التحقق من الدفع...</h2>
            <p className="text-sm text-gray-500">يرجى الانتظار</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-4" />
            <h2 className="text-lg font-bold text-gray-800 mb-2">تم الدفع بنجاح!</h2>
            <p className="text-sm text-gray-500">جاري تحويلك لصفحة الاشتراك...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <h2 className="text-lg font-bold text-gray-800 mb-2">فشل الدفع</h2>
            <p className="text-sm text-red-500 mb-4">{error}</p>
            <div className="flex gap-2 justify-center">
              <button onClick={() => navigate('/settings/subscription/upgrade')}
                className="bg-blue-600 text-white px-5 py-2.5 rounded-xl text-sm font-semibold hover:bg-blue-700">
                إعادة المحاولة
              </button>
              <button onClick={() => navigate('/settings/subscription')}
                className="bg-gray-100 text-gray-700 px-5 py-2.5 rounded-xl text-sm font-semibold hover:bg-gray-200">
                العودة للاشتراك
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
